module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noVacancies":"No Jobs yet"}}')
  delete Component.options._Ctor
}
